// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// Note: Firestore and Storage are optional - only import if you plan to use them
// import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAmWrWfA6Q47EKtvIiVppHXtAgg4po1FWo",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "harvesthelp-3c586.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "harvesthelp-3c586",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "harvesthelp-3c586.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "228018444301",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:228018444301:web:e1de50d505d780cd201d44",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-9BJ7JPSLT9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services (only what you need)
export const auth = getAuth(app);

// Optional services - only initialize if you plan to use them
// export const db = getFirestore(app);
// export const storage = getStorage(app);

// Initialize Analytics (only in browser environment)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Export the app instance
export default app;
